"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var assert = require("assert");

var EndOfFileStream_1 = require("./EndOfFileStream");

var EndOfFileStream_2 = require("./EndOfFileStream");

exports.EndOfStreamError = EndOfFileStream_2.EndOfStreamError;

var Deferred = function Deferred() {
  var _this = this;

  _classCallCheck(this, Deferred);

  this.promise = new Promise(function (resolve, reject) {
    _this.reject = reject;
    _this.resolve = resolve;
  });
};

var maxStreamReadSize = 1 * 1024 * 1024; // Maximum request length on read-stream operation

var StreamReader = /*#__PURE__*/function () {
  function StreamReader(s) {
    var _this2 = this;

    _classCallCheck(this, StreamReader);

    this.s = s;
    this.endOfStream = false;
    /**
     * Store peeked data
     * @type {Array}
     */

    this.peekQueue = [];

    if (!s.read || !s.once) {
      throw new Error('Expected an instance of stream.Readable');
    }

    this.s.once('end', function () {
      return _this2.reject(new EndOfFileStream_1.EndOfStreamError());
    });
    this.s.once('error', function (err) {
      return _this2.reject(err);
    });
    this.s.once('close', function () {
      return _this2.reject(new Error('Stream closed'));
    });
  }
  /**
   * Read ahead (peek) from stream. Subsequent read or peeks will return the same data
   * @param buffer - Buffer to store data read from stream in
   * @param offset - Offset buffer
   * @param length - Number of bytes to read
   * @returns Number of bytes peeked
   */


  _createClass(StreamReader, [{
    key: "peek",
    value: function () {
      var _peek = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(buffer, offset, length) {
        var bytesRead;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.read(buffer, offset, length);

              case 2:
                bytesRead = _context.sent;
                this.peekQueue.push(buffer.slice(offset, offset + bytesRead)); // Put read data back to peek buffer

                return _context.abrupt("return", bytesRead);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function peek(_x, _x2, _x3) {
        return _peek.apply(this, arguments);
      }

      return peek;
    }()
    /**
     * Read chunk from stream
     * @param buffer - Target buffer to store data read from stream in
     * @param offset - Offset of target buffer
     * @param length - Number of bytes to read
     * @returns Number of bytes read
     */

  }, {
    key: "read",
    value: function () {
      var _read2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(buffer, offset, length) {
        var remaining, bytesRead, peekData, lenCopy, reqLen, chunkLen;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(length === 0)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", 0);

              case 2:
                if (!(this.peekQueue.length === 0 && this.endOfStream)) {
                  _context2.next = 4;
                  break;
                }

                throw new EndOfFileStream_1.EndOfStreamError();

              case 4:
                remaining = length;
                bytesRead = 0; // consume peeked data first

                while (this.peekQueue.length > 0 && remaining > 0) {
                  peekData = this.peekQueue.pop(); // Front of queue

                  lenCopy = Math.min(peekData.length, remaining);
                  peekData.copy(buffer, offset + bytesRead, 0, lenCopy);
                  bytesRead += lenCopy;
                  remaining -= lenCopy;

                  if (lenCopy < peekData.length) {
                    // remainder back to queue
                    this.peekQueue.push(peekData.slice(lenCopy));
                  }
                } // continue reading from stream if required


              case 7:
                if (!(remaining > 0 && !this.endOfStream)) {
                  _context2.next = 18;
                  break;
                }

                reqLen = Math.min(remaining, maxStreamReadSize);
                _context2.next = 11;
                return this._read(buffer, offset + bytesRead, reqLen);

              case 11:
                chunkLen = _context2.sent;
                bytesRead += chunkLen;

                if (!(chunkLen < reqLen)) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("break", 18);

              case 15:
                remaining -= chunkLen;
                _context2.next = 7;
                break;

              case 18:
                return _context2.abrupt("return", bytesRead);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function read(_x4, _x5, _x6) {
        return _read2.apply(this, arguments);
      }

      return read;
    }()
    /**
     * Read chunk from stream
     * @param buffer Buffer to store data read from stream in
     * @param offset Offset buffer
     * @param length Number of bytes to read
     * @returns {any}
     */

  }, {
    key: "_read",
    value: function () {
      var _read3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(buffer, offset, length) {
        var _this3 = this;

        var readBuffer;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                assert.ok(!this.request, 'Concurrent read operation?');
                readBuffer = this.s.read(length);

                if (!readBuffer) {
                  _context3.next = 7;
                  break;
                }

                readBuffer.copy(buffer, offset);
                return _context3.abrupt("return", readBuffer.length);

              case 7:
                this.request = {
                  buffer: buffer,
                  offset: offset,
                  length: length,
                  deferred: new Deferred()
                };
                this.s.once('readable', function () {
                  _this3.tryRead();
                });
                return _context3.abrupt("return", this.request.deferred.promise.then(function (n) {
                  _this3.request = null;
                  return n;
                }, function (err) {
                  _this3.request = null;
                  throw err;
                }));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _read(_x7, _x8, _x9) {
        return _read3.apply(this, arguments);
      }

      return _read;
    }()
  }, {
    key: "tryRead",
    value: function tryRead() {
      var _this4 = this;

      var readBuffer = this.s.read(this.request.length);

      if (readBuffer) {
        readBuffer.copy(this.request.buffer, this.request.offset);
        this.request.deferred.resolve(readBuffer.length);
      } else {
        this.s.once('readable', function () {
          _this4.tryRead();
        });
      }
    }
  }, {
    key: "reject",
    value: function reject(err) {
      this.endOfStream = true;

      if (this.request) {
        this.request.deferred.reject(err);
        this.request = null;
      }
    }
  }]);

  return StreamReader;
}();

exports.StreamReader = StreamReader;